<template>
  <section :class="page">
    <particles v-if="['home', 'about-ai', 'invest'].includes($route.name)"/>
    <Header></Header>
    <main>
      <router-view ></router-view>
    </main>
    <footer>
      <div class="container">
        © 2009 - 2022 OOYYO LLC. All Rights Reserved.
      </div>
    </footer>
  </section>
</template>

<script>

import Particles from './components/Particles.vue';
import Header from './components/Header.vue';

export default {
  name: 'App',
  components: {
    Particles, Header
  },
  computed: {
    page() {
      return this.$route.meta.pageClass ? `page-${this.$route.meta.pageClass}` : `page-${this.$route.name}`
    }
  }
}
</script>
